import { render, staticRenderFns } from "./AddTeamMember.vue?vue&type=template&id=08c48b11&scoped=true&"
import script from "./AddTeamMember.vue?vue&type=script&lang=js&"
export * from "./AddTeamMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c48b11",
  null
  
)

export default component.exports